import {FeatureCollection, Point, Polygon} from 'geojson';
import {CancelablePromise} from '@zvne/fe-framework/dist/data-access/generic-types';
import {mapCancelablePromise} from '@zvne/fe-framework/dist/data-access/map-cencelable-promise';
import {axiosToCancelablePromise} from './reusable/axios-to-cencelable-promise';
import {configuration} from '../config/configuration';
import {axios} from './reusable/axios';

export interface LatestClusters {
    intervalSizeMinutes: number;
    lastUpdates: LastUpdate[];
    polygons: FeatureCollection<Polygon, LatestClusterProperties>;
    centroids: FeatureCollection<Point, LatestClusterProperties>;
}

export interface LastUpdate {
    timeId: number;
    timestamp: Date;
}

export interface LatestClusterProperties {
    timeId: number;
    timestamp: Date;
    prediction: number;
    clusterId: number;
    strokeCount: number;
    centroidX: number;
    centroidY: number;
}

interface Response {
    intervalSizeMinutes: number;
    lastUpdates: ResponseLatestTimestamp[];
    polygons: FeatureCollection<Polygon, ResponseProperties>;
    centroids: FeatureCollection<Point, ResponseProperties>;
}

interface ResponseLatestTimestamp {
    timeId: number;
    timestamp: string;
}

interface ResponseProperties {
    timeId: number;
    timestamp: string;
    prediction: number;
    clusterId: number;
    strokeCount: number;
    centroidX: number;
    centroidY: number;
}

export function getLatestClusters(): CancelablePromise<LatestClusters> {
    return mapCancelablePromise(
        axiosToCancelablePromise(cancelToken => axios.get<Response>(
            configuration.apiRoot + '/latest-clusters',
            {cancelToken: cancelToken}
        )),
        response => ({
            ...response,
            lastUpdates: response.lastUpdates.map(l => ({
                ...l,
                timestamp: new Date(l.timestamp)
            })),
            polygons: {
                ...response.polygons,
                features: response.polygons.features.map(f => ({
                    ...f,
                    properties: {
                        ...f.properties,
                        timestamp: new Date(f.properties.timestamp)
                    }
                }))
            },
            centroids: {
                ...response.centroids,
                features: response.centroids.features.map(f => ({
                    ...f,
                    properties: {
                        ...f.properties,
                        timestamp: new Date(f.properties.timestamp)
                    }
                }))
            }
        })
    );
}
